// extracted by mini-css-extract-plugin
export default {"svg":"ArrowIcon_svg__08gYo"};